import { Component, OnInit } from '@angular/core';
import { Constants } from '../../shared/common/helper/constants';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from '../../authentication/services/authentication.service';
import { Global } from '../../app.global';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.scss'],
})
export class AdminLayoutComponent implements OnInit {
  constants = Constants;
  selectedPanel = 'users';
  isUserAdmin = false;
  hasAdminAccess = false;

  constructor(
    public global: Global,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    this.onRouteChange();
    this.isUserAdmin = this.authService.isUserAdmin();
    this.hasAdminAccess = this.authService.hasAdminAccess();
    this.setActivePanel(this.router.url);
    this.global.isPcnPanelLocked = false;
  }

  onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActivePanel(event.url);
      }
    });
  }

  setActivePanel(url) {
    if (url.indexOf('/admin/policies') > -1) {
      this.selectedPanel = 'policies';
    } else if (url.indexOf('/admin/alerts') > -1) {
      this.selectedPanel = 'alerts';
    } else if (url.indexOf('/admin/settings') > -1) {
      this.selectedPanel = 'settings';
    } else if (url.indexOf('/admin/additionalExplanation') > -1) {
      this.selectedPanel = 'additionalExplanation';
    } else if (url.indexOf('/admin/configuration') > -1) {
      this.selectedPanel = 'configuration';
    } else if (url.indexOf('/admin/playground') > -1) {
      this.selectedPanel = 'playground';
    } else if (url.indexOf('/admin/letter-management') > -1) {
      this.selectedPanel = 'letter-management';
    } else if (url.indexOf('/admin/nexus') > -1) {
      this.selectedPanel = 'nexus';
    } else {
      this.selectedPanel = 'users';
    }
  }
}
